import React from 'react';
import { COLORS } from '../../globalvariables';

function Separator({ activeCategory }) {
  return (
    <div className="flex justify-center py-8" style={{ backgroundColor: 'transparent' }}>
      <div className="flex justify-between" style={{ width: '75%' }}>
      <div
          className="flex-1 h-2 rounded-full transition-all duration-500 ease-in-out"
        style={{
            backgroundColor:
              activeCategory === 'stores' ? COLORS.primary : COLORS.separatorInactive,
            transform: activeCategory === 'stores' ? 'scaleX(1.2)' : 'scaleX(1)',
            transformOrigin: 'center'
              }}
            ></div>
        <div className="w-8"></div>
            <div
          className="flex-1 h-2 rounded-full transition-all duration-500 ease-in-out"
              style={{
            backgroundColor:
              activeCategory === 'fashionDesigners' ? COLORS.primary : COLORS.separatorInactive,
            transform: activeCategory === 'fashionDesigners' ? 'scaleX(1.2)' : 'scaleX(1)',
            transformOrigin: 'center'
              }}
            ></div>
        <div className="w-8"></div>
            <div
          className="flex-1 h-2 rounded-full transition-all duration-500 ease-in-out"
              style={{
            backgroundColor:
              activeCategory === 'recyclingCompanies' ? COLORS.primary : COLORS.separatorInactive,
            transform: activeCategory === 'recyclingCompanies' ? 'scaleX(1.2)' : 'scaleX(1)',
            transformOrigin: 'center'
              }}
            ></div>
      </div>
    </div>
  );
}

export default Separator;